/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCR Master Mix Calculator (Reagent Volumes) — Toolverse`)
};

const es_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Master Mix para PCR (Volúmenes de Reactivos) — Toolverse`)
};

const de_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCR-Mastermix-Rechner (Reagenzienvolumina) — Toolverse`)
};

const nl_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCR-mastermixcalculator (Reagensvolumes) — Toolverse`)
};

const fr_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de mix maître PCR (volumes de réactifs) — Toolverse`)
};

const it_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore master mix PCR (volumi reagenti) — Toolverse`)
};

const pt_br2_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Master Mix de PCR (Volumes de Reagentes) — Toolverse`)
};

const pt_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Master Mix de PCR (Volumes de Reagentes) — Toolverse`)
};

const ja_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCRマスターミックス計算機(試薬量計算) — Toolverse`)
};

const zh_pcr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCR 混合液计算器（试剂用量） — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_meta_title", locale)
	if (locale === "en") return en_pcr_meta_title(inputs)
	if (locale === "es") return es_pcr_meta_title(inputs)
	if (locale === "de") return de_pcr_meta_title(inputs)
	if (locale === "nl") return nl_pcr_meta_title(inputs)
	if (locale === "fr") return fr_pcr_meta_title(inputs)
	if (locale === "it") return it_pcr_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_meta_title(inputs)
	if (locale === "pt") return pt_pcr_meta_title(inputs)
	if (locale === "ja") return ja_pcr_meta_title(inputs)
	return zh_pcr_meta_title(inputs)
};